import { createSelector } from '@opengov/compose-app/reselect';

import { selectSavedViewCurrentId, selectSavedViewIdFilter } from '../../common/savedViews/selectors/index';
import { reportSavedViewEditSelector } from '../state';

export const selectSavedViewEditState = createSelector(reportSavedViewEditSelector, (state) => state);

export const selectSavedViewEditActiveTabIndex = createSelector(
  reportSavedViewEditSelector,
  (state) => state.activeTabIndex
);

export const selectSavedViewEditActiveCategory = createSelector(
  reportSavedViewEditSelector,
  (state) => state.activeCategory
);

export const selectSavedViewEditShowSucessMessage = createSelector(
  reportSavedViewEditSelector,
  (state) => state.showSuccessMessage
);

export const selectCurrentSavedViewEditSavedView = createSelector(
  selectSavedViewIdFilter,
  selectSavedViewCurrentId,
  (svFilter, svCurrentId) => svFilter(svCurrentId)
);
